import { ArrowRightIcon } from "lucide-react";
import React from "react";
import { cards, colorVariants } from "./Data";
const OfferingCard = () => {
  const [isAnimated, setIsAnimated] = React.useState(false);
  React.useEffect(() => {
    const timer = setTimeout(() => setIsAnimated(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <style>{`
        .card-shine::after {
          content: "";
          position: absolute;
          top: 0;
          left: -150%; /* Start off-screen */
          width: 100%;
          height: 100%;
          transform: skewX(-25deg);
          background: linear-gradient(to right, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0));
          transition: left 0.6s cubic-bezier(0.23, 1, 0.32, 1);
        }
        .group:hover .card-shine::after {
          left: 150%; /* Animate to the other side */
        }
      `}</style>

      <section className="w-full bg-slate-50 font-sans antialiased">
        <div className="container mx-auto px-4 sm:px-4 lg:px-8 py-4 md:py-6 lg:py-8">
          <div className="text-center mb-4 md:mb-6">
            <h2 className="text-3xl sm:text-4xl lg:text-4xl font-extrabold text-gray-800 tracking-tight">
              <span className="relative inline-block">
                <span className="absolute inset-0 bg-sky-200/50 -skew-y-2 transform rounded-lg"></span>
                <span className="relative text-sky-600">Our Offerings </span>
              </span>{" "}
            </h2>
            <p className="mt-4 text-base sm:text-lg lg:text-xl text-gray-500 max-w-3xl mx-auto">
              {" "}
              Discover our comprehensive solutions in the drone industry,
              designed to meet your every need.{" "}
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
            {cards.map((card, index) => {
              const colors = colorVariants[card.color];
              return (
                <a
                  key={card.id}
                  href={card.link}
                  className={`group relative flex flex-col p-6 md:p-8 rounded-2xl overflow-hidden ${
                    colors.bg
                  } border-2 border-transparent ${colors.shadow} ${
                    colors.border
                  } 
                    
                    /* ANIMATION: Changed duration and easing for a smoother feel */
                    transition-all duration-500 [transition-timing-function:cubic-bezier(0.23,1,0.32,1)]
                    
                    hover:-translate-y-2
                    
                    /* ANIMATION: Enhanced entry animation with scale */
                    ${
                      isAnimated
                        ? "opacity-100 translate-y-0 scale-100"
                        : "opacity-0 translate-y-10 scale-95"
                    }`}
                  style={{
                    transitionDelay: `${isAnimated ? index * 100 : 0}ms`,
                  }}
                >
                  <div className="card-shine"></div>

                  <div
                    className={`w-14 h-14 md:w-16 md:h-16 rounded-full ${colors.iconBg} ${colors.text} flex items-center justify-center mb-5 md:mb-6 
                    transition-transform duration-300 [transition-timing-function:cubic-bezier(0.23,1,0.32,1)]
                    group-hover:scale-110 group-hover:-rotate-6`}
                  >
                    {card.icon}
                  </div>

                  <div className="text-left z-10">
                    <h3
                      className={`text-lg md:text-xl font-bold ${colors.text} mb-2 transition-colors duration-300`}
                    >
                      {card.title}
                    </h3>
                    <p className="text-gray-600 text-sm md:text-base leading-relaxed mb-4">
                      {card.description}
                    </p>
                  </div>

                  <div
                    className={`mt-auto pt-4 flex items-center gap-2 font-semibold text-sm ${colors.text} z-10
                    opacity-80 group-hover:opacity-100 transform group-hover:translate-x-2 
                    transition-all duration-300 [transition-timing-function:cubic-bezier(0.23,1,0.32,1)]`}
                  >
                    <span>{card.cta}</span>
                    <ArrowRightIcon className="w-[20px] h-[20px]" />
                  </div>
                </a>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
};

export default OfferingCard;
